import { useUnsavedChangesHandlers } from '@wix/rules-panel-ui';
import { useCallback } from 'react';
export const useNavigationGuard = handlers => {
  const contextHandlers = useUnsavedChangesHandlers();
  const unsavedChangesHandlers = handlers ?? contextHandlers;
  const guardNavigation = useCallback(navigationAction => {
    if (!unsavedChangesHandlers || !unsavedChangesHandlers.unsavedChanges.exists) {
      navigationAction();
      return;
    }
    unsavedChangesHandlers.showSaveBeforeLeaveModal(async () => {
      try {
        await unsavedChangesHandlers.unsavedChanges.apply();
        unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
        navigationAction();
      } catch (error) {
        console.error('Failed to save changes:', error);
      }
    }, () => {
      unsavedChangesHandlers.unsavedChanges.discard == null || unsavedChangesHandlers.unsavedChanges.discard();
      unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
      navigationAction();
    });
  }, [unsavedChangesHandlers]);
  return {
    guardNavigation,
    hasUnsavedChanges: unsavedChangesHandlers == null ? void 0 : unsavedChangesHandlers.unsavedChanges.exists
  };
};
//# sourceMappingURL=use-navigation-guard.js.map